import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdSettingsFallbackRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-settings-fallback',
	path: '/servicedesk/admin/:projectKey/:adminOption',
};
